import { render, staticRenderFns } from "./vipClass.vue?vue&type=template&id=7ca9258e&scoped=true"
import script from "./vipClass.vue?vue&type=script&lang=js"
export * from "./vipClass.vue?vue&type=script&lang=js"
import style0 from "./vipClass.vue?vue&type=style&index=0&id=7ca9258e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ca9258e",
  null
  
)

export default component.exports